import { FC } from 'react';
import AgendaGroup from 'modules/events/groups/AgendaGroup';
import OptionalInformationsGroup from 'modules/events/groups/OptionalInformationsGroup';
import PrimaryInformationsGroup from 'modules/events/groups/PrimaryInformationsGroup';
import SpeakersGroup from 'modules/events/groups/SpeakersGroup';
import TimeSlotGroup from 'modules/events/groups/TimeSlotGroup';
import useDetailsStep from 'modules/events/routes/CreateOnlineMeeting/Steps/DetailsStep/DetailsStep.hook';
import Box from 'yoda-ui/Box';

const DetailsStep: FC = () => {
  useDetailsStep();
  return (
    <Box>
      <TimeSlotGroup />
      <PrimaryInformationsGroup />
      <SpeakersGroup />
      <OptionalInformationsGroup />
      <AgendaGroup />
    </Box>
  );
};

export default DetailsStep;
